import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UnlinkAllOption } from '../../flag-manager.interfaces';

@Component({
  selector: 'app-flag-unlink-confirm-modal',
  templateUrl: './flag-unlink-confirm-modal.component.html',
  styleUrls: ['./flag-unlink-confirm-modal.component.scss'],
})
export class FlagUnlinkConfirmModalComponent implements AfterViewInit {
  UnlinkAllOption = UnlinkAllOption;

  @ViewChild('modalRef', { static: false }) modalRef!: ModalDirective;

  private resolver: ((value: UnlinkAllOption) => void) | null = null;

  ngAfterViewInit(): void {
    this.modalRef.onHidden.subscribe(() => {
      if (this.resolver) {
        this.resolver(UnlinkAllOption.CANCEL);
        this.resolver = null;
      }
    });
  }

  show(): Promise<UnlinkAllOption> {
    this.modalRef.show();
    return new Promise<UnlinkAllOption>(res => {
      this.resolver = res;
    });
  }

  resolveAndClose(option: UnlinkAllOption) {
    if (this.resolver) {
      this.resolver(option);
      this.resolver = null;
    }
    this.modalRef.hide();
  }
}
